#import "../fragments/peep-send-to-destinations-fragment.graphql"

query GetPeepSendToDestinations($id: ID!) {
    peep(id: $id) {
        ...PeepSendToDestinations
    }
}
